export enum CustomFieldType {
    Email = 'em',
    Phone = 'ph',
    Text = 'txt',
    Note = 'nt',
    Number = 'num',
    Date = 'd',
    DateTime = 'dt',
    Dropdown = 'dd',
    DropdownMulti = 'ddm',
    Boolean = 'bool',
    Address = 'add',
    Image = 'img',
    Link = 'link',
    // PickerEmployee = 'pemp',
    None = 'None'
}
